import { PAGINAS_BY_STEP } from '../../utils/constants';
import { capitalizeFirstLetter, checkIfHotjarEnable } from '../../utils/helpers';
import * as TYPE from '../types/sinister-cards';

const initialState = {
  userInfo: {
    documentType: null,
    document: null,
    name: null,
    fatherLastName: null,
    motherLastName: null,
    department: null,
    phone: null,
    email: null,
    terms: false,
    emailNotification: false,
  },
  sinisterList: [
    // {
    //   modalInfo: 'content',
    //   subtitle: 'Afilia a tu cónyuge y/o hijos a tu seguro de salud',
    //   redirect: '/content/rimac-siniestros-tarjetas/pages/demo2',
    //   modalImg: '/content/dam/rimac/siniestros-tarjetas/ModalPerson.svg',
    //   id: '3',
    //   name:
    //     'Uso indebido en establecimientos comerciales (compras presenciales)',
    //   imgProcedure:
    //     '/content/dam/rimac/siniestros-tarjetas/icon_cornershop.png',
    //   warningAdd:
    //     'Recuerda que los montos robados debieron ser retirados con una tarjeta BBVA y de un cajero BBVA.',
    //   soles: '',
    //   dollars: '',
    // },
    // {
    //   modalInfo: 'content',
    //   subtitle: 'Afilia a tu cónyuge y/o hijos a tu seguro de salud',
    //   redirect: '/content/rimac-siniestros-tarjetas/pages/demo2',
    //   modalImg: '/content/dam/rimac/siniestros-tarjetas/ModalPerson.svg',
    //   id: '4',
    //   name:
    //     'Uso indebido en establecimientos comerciales (compras presenciales)',
    //   imgProcedure:
    //     '/content/dam/rimac/siniestros-tarjetas/icon_cornershop.png',
    //   warningAdd:
    //     'Recuerda que los montos robados debieron ser retirados con una tarjeta BBVA y de un cajero BBVA.',
    //   soles: '',
    //   dollars: '',
    // },
  ],
  sinisterFiles: [],
  currentSinister: 0,
  sinisterNumberCase: '',
  currentStep: 0,
  accountInfo: [
    // {
    //   currency: 'PEN',
    //   bank: {
    //     text: null,
    //     value: null,
    //   },
    //   accountType: {
    //     text: null,
    //     value: null,
    //   },
    //   cci: '12312423423423423423',
    // },
    // {
    //   currency: 'USD',
    //   bank: {
    //     text: null,
    //     value: null,
    //   },
    //   accountType: {
    //     text: null,
    //     value: null,
    //   },
    //   cci: '12312423423423423423',
    // },
  ],
  totalSoles: '',
  totalDollars: '',
  otherDescription: '',
  otherInsurance: {
    otherInsurance: '',
    coverage: '',
  },
  filePayload: {
    payload: {
      data: {
        aseguradoDetalle: {
          tipoDocumento: 'DNI',
          numeroDocumento: '40454215',
          nombre: 'Cristián',
          apellidoPaterno: 'ss',
          apellidoMaterno: 'Mendoza',
        },
        subTipoDocumentos: [],
      },
    },
  },
  sinisterDate: null,
  sinisterHour: null
};

const sinisterCards = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.SET_SINISTER_LIST:
      let sinisterListCopy = [...action.payload].sort((a, b) => a.id - b.id);
      let sinistersAddMounts = sinisterListCopy.map((sinister) => {
        return sinister;
      });
      return {
        ...state,
        sinisterList: sinistersAddMounts,
      };
    case TYPE.INCREMENT_SINISTER:
      let currentSinister = state.currentSinister;
      if (currentSinister < state.sinisterList.length) {
        currentSinister += 1;
      }
      return {
        ...state,
        currentSinister: currentSinister,
      };
    case TYPE.SET_SINISTER:
      return {
        ...state,
        currentSinister: action.payload,
      };
    case TYPE.INCREMENT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };
    case TYPE.SET_STEP:
      if (action.payload && action.payload.plan && action.payload.step
        && action.payload.step < state.currentStep && checkIfHotjarEnable()) {
        // LAST
        window.digitalData.push({
          action: {
            group: 'Tramites Siniestros – Protección Tarjeta BBVA',
            category: `Reporta siniestro - ${capitalizeFirstLetter(action.payload.plan.toLowerCase())}`,
            name: 'Atrás',
            label: Object.entries(PAGINAS_BY_STEP).filter(([key, value]) => value.step === state.currentStep)[0][1].descripcion
          },
          event: 'trackAction'
        });
      }
      return {
        ...state,
        currentStep: action.payload.step ?? action.payload,
      };
    case TYPE.REDUCE_STEP:
      let step = state.currentStep;
      if (step >= 1) {
        step = step - 1;
      }
      if (action.payload && action.payload.plan && checkIfHotjarEnable()) {
        // LAST
        window.digitalData.push({
          action: {
            group: 'Tramites Siniestros – Protección Tarjeta BBVA',
            category: `Reporta siniestro - ${ capitalizeFirstLetter(action.payload.plan.toLowerCase()) }`,
            name: 'Atrás',
            label: Object.entries(PAGINAS_BY_STEP).filter(([key, value])=> value.step === state.currentStep)[0][1].descripcion
          },
          event: 'trackAction'
        });
      }
      return {
        ...state,
        currentStep: step,
      };
    case TYPE.UPDATE_SINISTER_LIST:
      let totalSoles = [...action.payload].reduce((prev, curr) => {
        return Number(Number(prev) + Number(curr.soles)).toFixed(2);
      }, 0);
      let totalDollars = [...action.payload].reduce((prev, curr) => {
        if (curr.dollars.length > 0) {
          return Number(Number(prev) + Number(curr.dollars)).toFixed(2);
        } else {
          return Number(Number(prev) + 0).toFixed(2);
        }
      }, 0);
      return {
        ...state,
        sinisterList: [...action.payload],
        totalSoles: totalSoles,
        totalDollars: totalDollars,
      };
    case TYPE.STORE_NEW_FILES:
      let newFiles = action.payload;
      let sinisterFilesCopy = [...state.sinisterFiles];
      let findItem = sinisterFilesCopy.filter(
        (item) => item.id === action.payload.id
      );
      // si ya esta upload
      if (findItem.length > 0) {
        let indexOfFindedIn = sinisterFilesCopy.indexOf(findItem[0]);
        sinisterFilesCopy.splice(indexOfFindedIn, 1);
      }
      let fileList = [...sinisterFilesCopy, newFiles].sort(
        (a, b) => a.id - b.id
      );
      return {
        ...state,
        sinisterFiles: [...fileList],
      };
    case TYPE.SET_ACCOUNT_INFO:
      return {
        ...state,
        accountInfo: [...action.payload],
      };
    case TYPE.REMOVE_SINISTER:
      let filterSinisters = [...state.sinisterList];
      filterSinisters.splice(action.payload, 1);
      return {
        ...state,
        sinisterList: [...filterSinisters],
      };
    case TYPE.SET_USER_INFO:
      // let filterSinisters = [...state.sinisterList]
      return {
        ...state,
        userInfo: action.payload,
      };
    case TYPE.SET_OTHER_INSURANCE:
      // let filterSinisters = [...state.sinisterList]
      return {
        ...state,
        otherInsurance: action.payload,
      };
    case TYPE.SET_SINISTER_DATE:
      // let filterSinisters = [...state.sinisterList]
      return {
        ...state,
        sinisterDate: action.payload.date,
        sinisterHour: action.payload.hour,
      };
    case TYPE.SET_SINISTER_NUMBER_CASE:
      return {
        ...state,
        sinisterNumberCase: action.payload,
      };
    case TYPE.SET_OTHER_DESCRIPTION:
      return {
        ...state,
        otherDescription: action.payload,
      };
    case TYPE.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default sinisterCards;
